import { createElement, forwardRef, type FC, type Ref } from "react";

/**
 *  react的函数柯里化
 * @param component 要封装的组件
 * @param partialProps 组件部分属性
 * @returns 
 * @example 
 function  A(props: {text: string}){
    return <div>{props.text}</div>
 }
 const HelloWorld = ReactCurry(A,  {text: "HelloWorld"})
 // <HelloWorld/> 输出   <div>HelloWorld"</div>
 */
export function curryReact<P>(component: FC<P>, partialProps: Partial<P>) {
  return forwardRef(function CurriedComponent(
    props: Partial<P>,
    ref: Ref<any>
  ) {
    return createElement(component, { ...partialProps, ...props, ref } as P);
  });
}
